const ENVIRONMENT_KEYS = ['local', 'dev', 'staging', 'prod'] as const;
type EnvironmentKey = (typeof ENVIRONMENT_KEYS)[number];
type EnvConfig = {
  webBuilderApiUrl: string;
};

export const CONSTANTS: Record<EnvironmentKey, EnvConfig> = {
  local: {
    webBuilderApiUrl: 'https://api.webbuilder.dev.photoboothsupplyco.dev',
  },
  dev: {
    webBuilderApiUrl: 'https://api.webbuilder.dev.photoboothsupplyco.dev',
  },
  staging: {
    webBuilderApiUrl: 'https://api.webbuilder.staging.photoboothsupplyco.dev',
  },
  prod: {
    webBuilderApiUrl: 'https://api.webbuilder.pbsco.app',
  },
};

export const getEnvUrl = (key: keyof EnvConfig) => {
  const isEnvironmentKey = (value: unknown): value is EnvironmentKey =>
    typeof value === 'string' && (ENVIRONMENT_KEYS as readonly string[]).includes(value);

  const rawEnv = process.env.NEXT_PUBLIC_ENV;
  if (rawEnv && !isEnvironmentKey(rawEnv)) {
    console.error(`Invalid environment key: ${rawEnv}`);
    return '';
  }

  const env: EnvironmentKey = rawEnv && isEnvironmentKey(rawEnv) ? rawEnv : 'local';
  return CONSTANTS[env][key];
};

export const TINYMCE_CLOUD_API_KEY =
  process.env.NEXT_PUBLIC_TINYMCE_CLOUD_API_KEY || 'ye1yjakfikdn9qaw8olen8448kim1bmhuifglvuse81dv974';
